<template>
  <div>
    <a-row>
      <div class="search-bar">
        <a-input class="mr-10" placeholder="项目编号" v-model="searchModel.ebelp"/>
        <a-button class="mr-10" type="primary" @click="initData">查询</a-button>
        <a-button class="mr-10" @click="clearSearch">重置</a-button>
      </div>
    </a-row>
    <a-row class="mb-10">
      <a-table
        bordered
        :pagination="tableData.pagination"
        :columns="tableData.columns"
        :rowKey="record => record.ebelp"
        :dataSource="tableData.data"
        :loading="tableData.loading"
        @change="handleTableChange"
      >
      </a-table>
    </a-row>

  </div>
</template>

<script>
import { getAssetEngineeringDetail } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    'model.ebeln': {
      handler (val) {
        console.log('触发', val)
        this.clear()
        this.initData()
      },
      immediate: true
    }
  },
  data () {
    return {
      searchModel: {
        ebelp: ''
      },
      tableData: {
        data: [],
        columns: [
          {
            title: '采购订单号',
            dataIndex: 'ebeln',
            align: 'center',
            width: 50
          },
          {
            title: '项目编号',
            dataIndex: 'ebelp',
            align: 'center',
            width: 50
          },
          {
            title: '采购订单金额（含税）',
            dataIndex: 'netwr',
            align: 'center',
            width: 50
          },
          {
            title: '订单创建日期',
            dataIndex: 'aedat',
            align: 'center',
            width: 50
          },
          {
            title: '入账金额（净价）',
            dataIndex: 'wrbtr',
            align: 'center',
            width: 50
          },
          {
            title: '入账日期',
            dataIndex: 'budatFi',
            align: 'center',
            width: 50
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          showQuickJumper: true
        },
        loading: false
      }
    }
  },
  methods: {
    async initData () {
      this.tableData.loading = true
      const { current, pageSize } = this.tableData.pagination
      const params = { ...this.searchModel, pageNum: current, pageSize, ebeln: this.model.ebeln }
      if (!params.ebelp) delete params.ebelp
      const res = await getAssetEngineeringDetail(params)
      if (res && res.status === 0) {
        this.tableData.data = res.data.list
        this.tableData.pagination.total = res.data.total
      } else {
        this.$message.error(res.info.message)
      }
      this.tableData.loading = false
    },
    handleTableChange (pagination) {
      this.tableData.pagination.pageSize = pagination.pageSize
      this.tableData.pagination.current = pagination.current
      this.initData()
    },
    clear () {
      this.searchModel.ebelp = ''
      this.tableData.data = []
      this.tableData.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      }
    },
    clearSearch () {
      this.searchModel.ebelp = ''
      this.initData()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-thead{
  height: 32px;
  & th{
    background: #E6ECF5;
  }
}
.search-bar{
  float: right;
  display: flex;
  margin: 15px 0;
}
.mr-10{
  margin-right: 10px;
}
.mb-10{
  margin-bottom: 10px;
}
</style>
